import { graphql } from "@/lib/gql/__generated__/gql";

export const PAYMENT_DEPOSIT_ACCOUNT_MUTATION = graphql(/* GraphQL */ `
	mutation PaymentDepositAccountMutation($input: PaymentDepositAccountInput!) {
		paymentDepositAccountUpdate(input: $input) {
			paymentDepositAccount {
				minimumTransferAmount
				id
				hotelID
				bankCode
				bankBranchCode
				bankAccountType
				bankAccountNumber
				bankAccountHolderName
			}
			userErrors
		}
	}
`);
